<template>
  <div class="content">
    <div class="mainbg">
      <div class="header">
        <div class='userInfo'>
          <div class='imgWrap'>
            <img :src="'https://zzbhzn.cn/prod-api/'+head" alt="">
          </div>
          <span>{{deptName}}</span>
        </div>
        <div class='exit' @click='Logout'>
          <img src='../assets/icon/exit.png'>
          <span style='margin-left:3px'>退出</span>
        </div>
      </div>
      <div class="sysName">智慧粮库云平台</div>
      <div class="mainBody">
        <div v-for="(item,index) in storageList" :key="index">
          <div :class="['sysNav',`nav${index+1}`,{navActive:num==index}]" @click="addClass(index)">
            <img :src="item.src" alt="">
            <span>{{item.name}}</span>
          </div>
        </div>
      </div>
      <div class="footer">
        <div>
          <span>{{company}} 版权所有</span>
          <span style='margin-left:15px'>版本号：{{version}}</span>
        </div>
        <div style='margin-left:15px'>售后电话：{{salesPhone}}</div>
      </div>
    </div>
  </div>
</template>

<script>

import axios from '../axios.js'
export default {
  data(){
    return{
      version:'',
      head:'',
      deptName:'',
      company:'',
      salesPhone:'',
      num:0,
      grain:false,
      wind:false,
      air:false,
      nitrogen:false,
      gasCheck:false,
      pestCheck:false,
      oilSituation:false,
      quantity:false,
      circulation:false,
      more:false,
      storageList:[
        {
          name:'粮情管理系统',
          src:require('../assets/nav/grain.png')
        },{
          name:'油情管理系统',
          src:require('../assets/nav/oil.png')
        },{
          name:'氮气气调系统',
          src:require('../assets/nav/n2.png')
        },{
          name:'环流控温系统',
          src:require('../assets/nav/cir.png')
        },{
          name:'环流熏蒸系统',
          src:require('../assets/nav/circulation.png')
        },{
          name:'智能通风系统',
          src:require('../assets/nav/vent.png')
        },{
          name:'气体检测系统',
          src:require('../assets/nav/airtest.png')
        },{
          name:'空调控温系统',
          src:require('../assets/nav/air.png')
        },{
          name:'虫害检测系统',
          src:require('../assets/nav/worm.png')
        },{
          name:'多功能系统',
          src:require('../assets/nav/multifunctional.png')
        },{
          name:'出入库管理系统',
          src:require('../assets/nav/outIn.png')
        },{
          name:'智能安防系统',
          src:require('../assets/nav/security.png')
        },{
          name:'系统配置',
          src:require('../assets/nav/system.png')
        },
        // {
        //   name:'管理中心',
        //   src:require('../assets/nav/homePage.png')
        // }
      ]
    }
  },
  created(){
    this.getInfo();
    this.getnum();
    this.getMenus()
  },
  methods:{
    getInfo(){
      axios.get('/wechat/info/getUserInfo').then(data=>{
        this.version=data.version;
        this.head=data.avatar;
        this.deptName=data.deptName;
        this.company=data.company;
        this.salesPhone=data.salesPhone;
      })
    },
    Logout(){
      axios.post('/logout').then(data=>{
        localStorage.removeItem('token');
        this.$router.push('/login')
      })
    },
    getMenus(){
      axios.get('/wechat/info/getMenus').then(data=>{
        data.list.forEach(item=>{
          if(item=='mini-grain'){
            this.grain=true
          }
          if(item=='mini-wind'){
            this.wind=true
          }
          if(item=='mini-air'){
            this.air=true
          }
          if(item=='mini-n2o'){
            this.nitrogen=true
          }
          if(item=='mini-gasCheck'){
            this.gasCheck=true
          }
          if(item=='mini-pestCheck'){
            this.pestCheck=true
          }
          if(item=='mini-num'){
            this.quantity=true
          }
          if(item=='mini-radar'){
            this.oilSituation=true
          }
          if(item=='mini-nhl'){
            this.circulation=true
          }
          if(item=='mini-more'){
            this.more=true
          }
        })
      })
    },
    getnum(){
      const num =localStorage.getItem('num');
      this.num=num?num:0
    },
    addClass(num){
      localStorage.setItem('num', num);
      if(num==0){
        if(this.grain){
          this.$router.push({name:'currency',params:{nav:'grain'}})
        }else{
          this.$message({
            message:'未获得使用权限',
            type:'warning',
            duration:1000
          })
        }
      }else if(num==1){
        if(this.oilSituation){
          this.$router.push({name:'currency',params:{nav:'oil'}})
        }else{
          this.$message({
            message:'未获得使用权限',
            type:'warning',
            duration:1000
          })
        }
      }else if(num==2){
        this.$router.push({name:'currency',params:{nav:'nitrogen'}})
        if(this.nitrogen){
          this.$router.push({name:'currency',params:{nav:'nitrogen'}})
        }else{
          this.$message({
            message:'未获得使用权限',
            type:'warning',
            duration:1000
          })
        }
      }else if(num==3){
        if(this.circulation){
          this.$router.push({name:'currency',params:{nav:'circulation'}})
        }else{
          this.$message({
            message:'未获得使用权限',
            type:'warning',
            duration:1000
          })
        }
      }else if(num==4){
        this.$message({
          message:'敬请等待后期开发',
          type:'warning',
          duration:1000
        })
      }else if(num==5){
        if(this.wind){
          // this.$router.push({name:'currency',params:{nav:'wind'}})
          this.$message({
            message:'敬请等待后期开发',
            type:'warning',
            duration:1000
          })
        }else{
          this.$message({
            message:'未获得使用权限',
            type:'warning',
            duration:1000
          })
        }
      }else if(num==6){
        if(this.gasCheck){
          this.$router.push({name:'currency',params:{nav:'gasCheck'}})
        }else{
          this.$message({
            message:'未获得使用权限',
            type:'warning',
            duration:1000
          })
        }
      }else if(num==7){
        if(this.air){
          this.$router.push({name:'currency',params:{nav:'air'}})
        }else{
          this.$message({
            message:'未获得使用权限',
            type:'warning',
            duration:1000
          })
        }
      }else if(num==8){
        if(this.pestCheck){
          // this.$router.push('/wormCheck')
          this.$message({
            message:'敬请等待后期开发',
            type:'warning',
            duration:1000
          })
        }else{
          this.$message({
            message:'未获得使用权限',
            type:'warning',
            duration:1000
          })
        }
      }else if(num==9){
        if(this.more){
          this.$router.push({name:'currency',params:{nav:'multifunctional'}})
        }else{
          this.$message({
            message:'未获得使用权限',
            type:'warning',
            duration:1000
          })
        }
      }else if(num==10){
        this.$message({
          message:'敬请等待后期开发',
          type:'warning',
          duration:1000
        })
      }else if(num==11){
        this.$message({
          message:'敬请等待后期开发',
          type:'warning',
          duration:1000
        })
      }else if(num==12){
        this.$router.push({name:'currency',params:{nav:'system'}})
      }else if(num==13){
        this.$router.push({name:'currency',params:{nav:'home'}})
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .mainbg{
    height: 100%;
    width: 100%;
    background-image: url("../assets/images/index.png");
    background-position: center bottom;
    display: flex;
    flex-direction: column;
    align-items: center;
    .header{
      width: 100%;
      height: 64px;
      background-color: rgba(255,255,255,.5);
      box-shadow: 0 1px 6px 0 rgba(88,120,210,.2);
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-size: 14px;
      color: #242424;
      font-weight: 400;
      .userInfo{
        display: flex;
        align-items: center;
        margin-right: 25px;
        .imgWrap{
          border: 1px solid rgba(0,0,0,.1);
          height: 32px;
          width: 32px;
          border-radius: 50%;
          overflow: hidden;
          margin-right: 5px;
          img{
            height: 32px;
            width: 32px
          }
        }
      }
      .exit{
        display: flex;
        align-items: center;
        width: 75px;
        cursor: pointer;
      }
    }
    .sysName{
      font-size: 36px;
      font-weight: bold;
      color: #242424;
      margin: 43px 0;
    }
    .mainBody{
      height: 666px;
      width: 1253px;
      box-sizing: border-box;
      .sysNav{
        background: rgba(255, 255, 255, 0.28);
        border-radius: 10px;
        box-shadow: inset 0 1px 1px 0 #ffffff,
                    0 1px 6px 0 rgba(177, 190,255,0.5);
        opacity: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        font-weight: bold;
        margin-bottom: 20px;
        cursor: pointer;
        width:192px;
        height:206px;
        float: left;
        margin-right:20px;
        img{
          height: 96px;
          width: 96px
        }
      }
      .nav1,.nav2{
        height: 434px;
      }
      .nav3{
        width: 404px;
      }
      .nav5{
        margin-right: 0
      }
      .nav8{
        margin-right: 0;
        width: 404px
      }
      .nav9{
        clear:both
      }
      .nav11{
        width: 404px;
      }
      .nav13{
        margin-right: 0
      }
      .navActive{
        background-color: #ffffff;
        box-shadow: 0 8px 30px 0 rgba(40,120,255,.2)
      }
    }
    .footer{
      font-size: 14px;
      font-weight: 400;
      color: #292929;
      height: 60px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      span{
        display: inline-block;
        border-right:1px solid rgba(0,0,0,.4);
        padding-right: 15px;
        height: 10px;
        line-height: 10px
      }
    }
  }
</style>
